import { render, staticRenderFns } from "./OrganizationDetails.vue?vue&type=template&id=4b10c7f5&scoped=true&"
import script from "./OrganizationDetails.vue?vue&type=script&lang=ts&"
export * from "./OrganizationDetails.vue?vue&type=script&lang=ts&"
import style0 from "./OrganizationDetails.vue?vue&type=style&index=0&id=4b10c7f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b10c7f5",
  null
  
)

export default component.exports